import React from "react";
import { userService } from "../../libs/authLib";

/* Design assets */
import './Login.css';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import VerifiedUser from '@material-ui/icons/VerifiedUser';
import Button from '@material-ui/core/Button/Button';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import Fade from '@material-ui/core/Fade'; 


const styles = theme => ({
  root: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    marginTop: theme.spacing.unit * 3,
    opacity: 0.8,    
  }),
  
  button: {
    margin: theme.spacing.unit,
    // background: 'linear-gradient(45deg, #90CAF9 20%, #BBDEFB 90%)',
    backgroundColor: '#3ab9c5',
    border: '1px solid black',
    fontSize: 16,
    
  },
  leftIcon: {
    marginRight: theme.spacing.unit,
  },
  rightIcon: {
    marginLeft: theme.spacing.unit,
  },
  
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200,     
  },
  textFieldInput: {
    fontSize: 16,
    },
  textFieldFormLabel: {
    fontSize: 16,    
  },
  placeholder: {
    height: 40
  }
});
/* Design assets end */


class Login extends React.Component {
  
  constructor(props){
    super(props);

    this.state = {
      orgId: "",
      orgIdError: "",
      username: "",
      usernameError: "",
      password: "",
      passwordError: "",
      authenticationError: "",
      loading: false
    };
  }

  

  handleChange = name => event => {
      this.setState({
        [name]: event.target.value,
      });
    };
  
  

  handleFocus = name => event => {
    var x = [name] + "Error";    
    this.setState({[x]: ""});
    this.setState({authenticationError: ""});
    
   // console.log(this.state); 
     
  }


  validate = () => {
    let isError = false;
    const errors = {
      orgIdError: "",
      usernameError: "",
      passwordError: ""
    };

    let orgId = this.state.orgId.trimEnd();
    let username = this.state.username.trimEnd();


    if (username.length < 5) {
      isError = true;
      errors.usernameError = "Invalid Username";
    }
    else if (username.indexOf("@") === -1){        
      isError = true;
      errors.usernameError = "Requires valid information";
    }

    if (this.state.password.length < 5) {
        isError = true;
        errors.passwordError = "Invalid password";
    }

    if (orgId.length < 2) {
      isError = true;
      errors.orgIdError = "Invalid Organization Id";
    }

    this.setState({
      ...this.state,
      ...errors
    });

    return isError;
  };

  onSubmit = async e => {
    e.preventDefault();
      
    


    const err = this.validate();
    
    

    if (!err) {
      let orgId = this.state.orgId.trimEnd();
      let username = this.state.username.trimEnd();
      
      try {
        this.setState({ loading: true });
        let x = await userService.login(username, this.state.password, orgId);
        
        if (x) {	
          this.props.userHasAuthenticated(true);    
          if(this.state.authenticationError.length > 0){
            this.setState({authenticationError:""});
          }
          this.setState({loading: false});
       } else {
          throw (e);
       }

      } catch (e) {
        //alert(e);        
        this.setState({authenticationError: 'Invalid credentials. Please try again'});
        this.setState({ isAuthenticating: false });
        this.setState({loading: false});
      }
    }
  };

  render() {   
    const { classes } = this.props; 
    const { loading } = this.state;

    return (  
      <div className="wrapper">
      
      <Paper className={classes.root}>      
      <h3 className="title">MicroKeyVault Mobile</h3>
      {this.state.authenticationError &&
        <div className="alert-danger">{this.state.authenticationError}</div>  
      }
      <form onSubmit={e => this.onSubmit(e)}>
      
        <FormControl error aria-describedby="orgId-error-text" >
        <TextField
          id="orgId"
          label="Organization Id"
          className={classes.textField}
          value={this.state.orgId}
          onChange={this.handleChange('orgId')}
          onFocus={this.handleFocus('orgId')}
          margin="normal" 
          required
          InputLabelProps={{            
            className: classes.textFieldFormLabel,
          }} 
          InputProps={{
            className: classes.textFieldInput,
          }}          
        />
        <FormHelperText id="orgId-error-text" className={classes.textFieldFormLabel}>{this.state.orgIdError}</FormHelperText>
        </FormControl>       
        <br />
        <FormControl error aria-describedby="username-error-text" >
        <TextField
          id="username"
          label="User name"
          className={classes.textField}
          value={this.state.username}
          onChange={this.handleChange('username')}
          onFocus={this.handleFocus('username')}
          margin="normal" 
          required
          InputLabelProps={{            
            className: classes.textFieldFormLabel,
          }} 
          InputProps={{
            className: classes.textFieldInput,
          }}          
        />
        <FormHelperText id="username-error-text" className={classes.textFieldFormLabel}>{this.state.usernameError}</FormHelperText>
        </FormControl>       
        <br />
        <FormControl error aria-describedby="password-error-text">
        <TextField
          id="password"
          label="Password"
          className={classes.textField}
          value={this.state.password}
          onChange={this.handleChange('password')}
          onFocus={this.handleFocus('password')}
          margin="normal" 
          type="password"  
          required
          InputLabelProps={{            
            className: classes.textFieldFormLabel,
          }}  
          InputProps={{
            className: classes.textFieldInput,
          }}       
        />
        <FormHelperText id="password-error-text" className={classes.textFieldFormLabel}>{this.state.passwordError}</FormHelperText>
        </FormControl>           
        <br /> 
        <div style={{textAlign: 'center'}}> 
        
        <Button className={classes.button}   type="submit"  disabled={loading}>
        Login
        
        <VerifiedUser className={classes.rightIcon} />
        {<Fade
            in={loading}
            style={{
              transitionDelay: loading ? '800ms' : '0ms',
            }}
            unmountOnExit
          >
            <CircularProgress />
          </Fade>}
        </Button>        
          
      </div>
      </form>
      </Paper> 
      {/* <footer>&copy; 2019 Midwest Security Products, Inc.<br/> All Rights Reserved.</footer> */}
      </div>
    );
  }
}
export default withStyles(styles)(Login);


// WEBPACK FOOTER //
// ./src/containers/Login/login.js